<template>
    <div class="main" id="mainwrap">
        <tweetCon :articleInfo="articleInfo"></tweetCon>
        <comments :articleId="article_id" :time="3000" v-if="loadItem"></comments>
        <downloadFooter v-if="bodyLoad && loadItem && !isInApp" v-once :text="$t('downloadForComments')"></downloadFooter>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex';
import tweetCon from '@/components/tweetCon.vue';
import comments from '@/components/comments.vue';
import downloadFooter from '@/components/downloadFooter.vue';

export default {
    name: 'app',
    data () {
        return {
            title: '',
            article_id: parseInt(this.$route.query.id, 10),
            bodyLoad: false,
            loadItem: false,
            isInApp: process.env.VUE_ENV === 'server' ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL,
        };
    },
    computed: {
        // ...mapGetters([
        //     'getArticleInfo'
        // ]),
        articleInfo () {
            // return this.$store.state.tweetStore.articleInfo || {};
            return this.$store.state.tweetStore.articleInfo[this.article_id] || {};
        }
    },
    asyncData ({ store, route: { query: { id } } }) {
        // 此函数会在组件实例化之前执行，故直接将store,route传入；
        if (id) {
            return store.dispatch('getArticleInfo', { article_id: id });
        } else {
            return Promise.reject();
        }
    },
    head () {
        const isHaveMedia = (this.articleInfo && this.articleInfo.entities) || null;
        const HOST = process.env.NODE_ENV === 'production' ? 'https://m-yinni.allsepakbola.net' : 'https://beta-m-yinni.allfootballapp.com';
        const title = ((this.articleInfo && this.articleInfo.text) || '') + '| All Sepakbola';
        const shareUrl = HOST + this.$route.fullPath;
        const shareImg =
            (isHaveMedia && isHaveMedia.media && isHaveMedia.media.photo && isHaveMedia.media.photo[0] && isHaveMedia.media.photo[0].original.url) ||
            (isHaveMedia && isHaveMedia.media && isHaveMedia.media.video && isHaveMedia.media.video.cover) ||
            'http://img.allfootballapp.com/www/M00/52/A6/rB8CLF1hHy2AWL55AAm0BGPys88585.png';
        const description = (this.articleInfo && this.articleInfo.text) || 'Visit All Sepakbola to get football news, live scores, highlights, videos and commentary for EPL, La Liga, Bundesliga, Serie A';
        let keywords = 'All Sepakbola';
        const link = [];
        return {
            title,
            link,
            meta: [
                {
                    name: 'description',
                    content: description.replace(/<(.*?)>/g, '')
                },
                {
                    name: 'keywords',
                    content: keywords
                },
                { name: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:site', content: '@allfootballapp' },
                { name: 'twitter:creator', content: '@allfootballapp' },
                { name: 'twitter:app:id:ipad', content: '' },
                { name: 'twitter:title', content: title },
                { name: 'twitter:description', content: title },
                { name: 'twitter:image', content: shareImg },
                // facebook
                { name: 'fb:app_id', content: 'summary_large_image' },
                { name: 'og:url', content: shareUrl },
                { name: 'og:type', content: 'article' },

                // for twiter and facebook
                { name: 'og:title', content: title },
                { name: 'og:description', content: title },
                { name: 'og:image', content: shareImg },
                { name: 'og:site_name', content: 'AllfootballOfficial' }
            ]
        };
    },
    created: function () {
    },
    mounted: function () {
        // 分享页历史重置
        const query = this.$route.query || {};
        if (window.history && query.type && query.type === 'tweet') {
            const fullPath = this.$route.fullPath;
            console.log(fullPath);
            history.replaceState(null, 'share', '/home?utm_source=APP_SHARE');
            history.pushState(null, 'share', fullPath);

            window.addEventListener('popstate', function (event) {
                if (location.pathname !== '/tweet') {
                    location.reload();
                }
            });
        }
        let mainwrap = document.getElementById('mainwrap');
        if (!this.articleInfo) return;
        this.bodyLoad = true;
        if (mainwrap.offsetHeight - window.screen.height - 100 > 0) {
            this.loadItem = false;
            window.addEventListener('scroll', this.loadmoreFn, false);
        } else {
            this.loadItem = true;
        }
    },
    methods: {
        loadmoreFn: function () {
            if ((document.documentElement.scrollTop || document.body.scrollTop) > 10) {
                if (this.loadItem) return;
                this.loadItem = true;
                window.removeEventListener('scroll', this.loadmoreFn, false);
            }
        }
    },
    components: {
        tweetCon, comments, downloadFooter
    }
};
</script>

<style scoped lang="less">
    .operamini-tips {
        background: #FFFF00;
        text-align: center;
        font-weight: bold;
    }

    .links {
        font-size: 14px;
        padding: 0 15px 0 15px;
        color: #fff;
        a {
            color: #fff;
        }
    }
</style>



// WEBPACK FOOTER //
// AppTweet.vue?71d66716